<template>
    <div class="col-md-12">
        <div class="row">
            <div class="col-md-4 pl-0">
                <v-select
                    :options="billingMonths"
                    v-model="selectedBillingMonth"
                    :get-option-label="getLabel"
                    @input="filterUsage(selectedBillingMonth)"
                    placeholder="Select billing month"
                >
                </v-select>
            </div>
        </div>
        <div class="row row-spacing">
            <div class="table-responsive">
                <table class="table table-bordered">
                    <thead>
                        <tr>
                            <th>Bundle usage (GB)</th>
                            <th>Over usage (GB)</th>
                            <th>Total usage (GB)</th>
                        </tr>
                    </thead>
                    <tbody v-if="usage">
                        <tr>
                            <td>{{ sizeBytesToGb(usage.bundleUsage) }}</td>
                            <td>{{ sizeBytesToGb(usage.overUsage) }}</td>
                            <td>{{ sizeBytesToGb(usage.totalUsage) }}</td>
                        </tr>
                    </tbody>
                    <tbody v-else>
                        <tr>
                            <td colspan="3">No usage</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        apnUsageNumber: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            billingMonths: [],
            selectedBillingMonth: 0,
            usage: null
        }
    },
    mounted() {
        this.getBillingMonths();
    },
    methods: {
        getBillingMonths: function() {
            const hostUrl = this.$config.aimsAPI;

            this.$http.get(`${hostUrl}privatemtnapn/billingmonths`).then(
                (response) => {
                    this.billingMonths = response.data;
                },
                (error) => {
                    console.error(error);
                    this.showError('Error fetching billing months', error);
                }
            );
        },
        filterUsage: function(period) {
            const hostUrl = this.$config.aimsAPI;

            this.$http.get(`${hostUrl}privatemtnapn/usage/${this.apnUsageNumber}/period/${period}`).then(
                (response) => {
                    this.usage = response.data;
                },
                (error) => {
                    console.error(error);
                    this.showError('Error fetching APN usage', error);
                }
            );
        },
        getLabel: function(period) {
            return this.prettifyBillingPeriod(period);
        },
    }
}
</script>

<style lang="scss" scoped>
// A global, unscoped style (BankStatements.vue) leaks `position: sticky; z-index: 2`
// onto every table header in the app. That sticky positioning is what lets this table's
// header paint over the billing-month dropdown once it's ever been "stuck" - z-index alone
// doesn't reliably win against a sticky ancestor. Opt this table out: a static header can
// never out-stack the dropdown's `position: absolute; z-index: 1000`, and a sticky header
// isn't useful here anyway (the table only ever has one row).
table thead tr th {
    position: static;
}
</style>
